import React from 'react'
import { Check } from 'lucide-react'
import { PrimaryButton } from '@/shared/components/ui/Button/PrimaryButton'
import { useAddRecommendedAccount } from '@/features/dashboard/components/accountsDashboard/similarAccounts/useAddRecommendedAccount'

const PrimaryButtonComponent = PrimaryButton as React.ComponentType<any>

/** Drawer footer action: add the open company as an account without closing the panel. */
export default function AddToAccountsButton({ account }: { account: any }) {
    const { add, canAdd, isAdding, isAdded, hasDomain } = (useAddRecommendedAccount as any)(account)
    return (
        <PrimaryButtonComponent
            startContent={isAdded ? <Check size={16} className='text-white' /> : undefined}
            onClick={add}
            isLoading={isAdding}
            disabled={!canAdd}
            title={!hasDomain ? 'This company has no website, so it cannot be added yet' : undefined}
            className='w-full justify-center !h-10 text-sm'
        >
            {isAdded ? 'Added to accounts' : isAdding ? 'Adding...' : 'Add to accounts'}
        </PrimaryButtonComponent>
    )
}
